const id_purch_invoice = {
    "": "tagihan pembelian",
    add: "buat tagihan pembelian",
    detail: "detail tagihan pembelian",
    edit: "ubah tagihan pembelian",
    payment: "daftar pembayaran tagihan pembelian",

    label: {
        file: "bukti tagihan",
        date_create: "tanggal pembuatan tagihan",
        po_list_title: "daftar PO",
    },

    message: {
        cancel_title: "Apakah Anda yakin untuk membatalkan tagian ?",
        cancel_text: "Masukkan alasan pembatalan tagihan.",
    },

    error: {
        create: "Gagal membuat tagihan pembelian.",
        edit: "Gagal mengubah tagihan pembelian.",
        cancel: "Gagal membatalkan tagihan pembelian.",
    },

    success: {
        create: "Berhasil membuat tagihan pembelian.",
        edit: "Berhasil mengubah tagihan pembelian.",
        cancel: "Berhasil membatalkan tagihan pembelian.",
    },
}

export default id_purch_invoice;